
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-report-scammers",
      function () {
        return require("private-next-pages/how-to-report-scammers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-report-scammers"])
      });
    }
  